module.exports = __webpack_public_path__ + "static/media/logos7.c5345c87.png";